<template>
  <div class="tabs-underline">
    <button
      v-for="tab in tabs"
      :key="tab.value"
      type="button"
      class="tabs-underline-item"
      :class="{ 'is-active': tab.value === value }"
      @click="$emit('input', tab.value)"
    >
      {{ tab.label }}
      <span v-if="tab.count" class="tabs-underline-badge">{{ tab.count }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "TabsUnderline",
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    value: {
      type: [String, Number],
      default: null,
    },
  },
};
</script>

<style scoped>
.tabs-underline {
  align-items: center;
  border-bottom: 1px solid #e2e6ea;
  display: flex;
  flex-wrap: wrap;
  column-gap: 28px;
  margin-bottom: 20px;
}

.tabs-underline-item {
  background: none;
  border: none;
  color: #8a97a5;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  outline: none;
  padding: 10px 2px 12px;
  position: relative;
  white-space: nowrap;
}

.tabs-underline-item:focus,
.tabs-underline-item:focus-visible,
.tabs-underline-item:active {
  box-shadow: none;
  outline: none;
}

.tabs-underline-item:hover {
  color: #1e73be;
}

.tabs-underline-item.is-active {
  color: #1e73be;
}

.tabs-underline-item.is-active::after {
  background: #1e73be;
  border-radius: 2px 2px 0 0;
  bottom: -1px;
  content: "";
  height: 2px;
  left: 0;
  position: absolute;
  right: 0;
}

@media (max-width: 576px) {
  .tabs-underline {
    column-gap: 20px;
  }
}

.tabs-underline-badge {
  background: #f0ad4e;
  border-radius: 10px;
  color: #ffffff;
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  margin-left: 6px;
  padding: 3px 7px;
  vertical-align: middle;
}
</style>
